import CityPageTemplate from "../city-template/CityPageTemplate";
import { knoxvilleConfig } from "./data";

export default function KnoxvillePage() {
  return <CityPageTemplate config={knoxvilleConfig} />;
}